export const REVIEW_CREATED = 'REVIEW_CREATED';
export const REVIEW_REMOVED = 'REVIEW_REMOVED';
export const REVIEW_COMPLETED = 'REVIEW_COMPLETED';

export const EMPLOYEE_ADDED = 'EMPLOYEE_ADDED';
export const EMPLOYEE_REMOVED = 'EMPLOYEE_REMOVED';